import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { openedPrepared } from "./prerendu";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    // 🚀 Page préparée (tour 55) : au démarrage du site, le visiteur a pu déjà faire défiler la page
    // préparée. Elle reste où il est, au lieu de remonter d'un coup en haut
    const opening = first.current;
    first.current = false;
    if (opening && openedPrepared()) return;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
